import { useState, useEffect } from 'react';
import style from './style.module.css';

const HeadingWithIcon = ({
  icon,
  heading,
  children,
  count: initialCount,
  totalCount: initialTotalCount,
  isDesc = false,
  toggleDesc,
  isAttachment = false,
  isChecklist = false,
  showIcon = true
}) => {

  const [count, setCount] = useState(initialCount || 0);
  const [totalCount, setTotalCount] = useState(initialTotalCount || 0);

  // Keep state in sync if props change
  useEffect(() => {
    setCount(initialCount || 0);
  }, [initialCount]);

  useEffect(() => {
    setTotalCount(initialTotalCount || 0);
  }, [initialTotalCount]);

  return (
    <div className={style.heading_with_icon_wrapper}>
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between">
          <div className={style.heading}>
            {heading}{' '}
            
            {(totalCount > 0 || (isAttachment && count > 0)) && (
              <span className={style.task_counts}>
                {isChecklist ? `(${totalCount})` : `(${count}${isAttachment ? "" : `/${totalCount}`})`}
              </span>
            )}

            {isDesc && showIcon && (
              <img
                src={icon}
                width="20px"
                alt="hello-icon"
                className={style.desc_icon}
                onClick={toggleDesc}
              />
            )}
          </div>

          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default HeadingWithIcon;
